import React from 'react';
import { Button } from 'reactstrap';

const ReferralStatusBtn = ({ referral }) => {
    if (
        referral.caseStatus === 'Declined' ||
        referral.caseStatus === 'Cancelled'
    ) {
        return (
            <Button
                size="sm"
                color="light-danger"
                className="search-status-btn"
            >
                {referral.caseStatus === 'Cancelled'
                    ? 'Canceled'
                    : referral.caseStatus}
            </Button>
        );
    }

    if (referral.caseStatus === 'Pending') {
        return (
            <Button size="sm" className="search-status-btn">
                New
            </Button>
        );
    }

    if (referral.caseStatus === 'Uncompleted') {
        return (
            <Button size="sm" color="blue" className="search-status-btn">
                {referral.waitingStatus}
            </Button>
        );
    }

    return (
        <Button size="sm" color="primary" className="search-status-btn">
            {referral.caseStatus}
        </Button>
    );
};

export default ReferralStatusBtn;
